// @ts-nocheck
<template>
  <!-- @ts-ignore -->
  <fwb-button v-bind="$attrs" :class="classes">
    <div :class="divClasses">
      <TwcIcon v-if="icon" :icon="icon" :class="{ 'mr-2': $slots.default }" />
      <slot></slot>
      <TwcSpinner v-if="loading" color="text-white" class="ml-2 h-[15px] w-[15px]" />
    </div>
  </fwb-button>
</template>

<script lang="ts" setup>
import { FwbButton } from 'flowbite-vue'
import { computed, useAttrs } from 'vue'
import { TwcIcon, TwcSpinner } from '@/components/web-components/twc'
const props = defineProps({
  flat: {
    type: Boolean,
    default: false
  },

  link: {
    type: Boolean,
    default: false
  },

  secondary: {
    type: Boolean,
    default: false
  },

  icon: {
    type: String,
    default: ''
  },

  small: {
    type: Boolean,
    default: false
  },

  medium: {
    type: Boolean,
    default: false
  },

  full: {
    type: Boolean,
    default: false
  },

  xsmall: {
    type: Boolean,
    default: false
  },

  red: {
    type: Boolean,
    default: false
  },

  green: {
    type: Boolean,
    default: false
  },

  blue: {
    type: Boolean,
    default: false
  },

  loading: {
    type: Boolean,
    default: false
  },

  fat: {
    type: Boolean,
    default: false
  },

  inline: {
    type: Boolean,
    default: false
  },

  wrap: {
    type: Boolean,
    default: false
  }
})

const attrs = useAttrs()

const classes = computed(() => {
  let result =
    'TwcButton bg-dashboard-action-blue hover:bg-dashboard-action-blue-light text-base focus:ring-2 focus:ring-blue-500 focus:border-transparent'

  if (props.fat) {
    result = `${result} p-4`
  }

  if (props.small) {
    result = `${result} text-sm`
  }

  if (props.medium) {
    result = `${result} text-base h-[42px]`
  }

  if (props.xsmall) {
    result = `${result} text-xs`
  }

  if (props.full) {
    result = `${result} w-full`
  }

  if (props.flat) {
    result = `${result} border bg-transparent text-gray-800 hover:bg-gray-200`
  }

  if (props.secondary) {
    result = `${result} border bg-white ${attrs.disabled ? 'cursor-default' : 'hover:text-white'}`

    if (props.blue) {
      result = `${result} border-dashboard-action-blue text-dashboard-action-blue ${attrs.disabled ? 'hover:bg-white' : 'hover:bg-dashboard-action-blue'}`
    } else {
      result = `${result} border-black text-gray-800 ${attrs.disabled ? 'hover:bg-white' : 'hover:bg-dashboard-blue'}`
    }
  }

  if (props.link) {
    result = `${result} border-0 bg-transparent text-dashboard-action-blue hover:bg-dashboard-action-blue-light hover:bg-transparent p-0 whitespace-nowrap`
  }

  if (props.red) {
    if (!props.link)
      result = `${result} border border-dashboard-error-red hover:bg-dashboard-error-red hover:text-white`
    result = `${result} bg-white text-dashboard-error-red`
  }

  if (props.green) {
    result = `${result} border border-dashboard-success-green bg-white text-dashboard-success-green`
    result = `${result} hover:bg-dashboard-success-green hover:text-white`
  }

  return result
})

const divClasses = computed(
  () =>
    `${props.inline ? 'inline-flex' : 'flex justify-center'} items-center ${props.wrap ? 'whitespace-normal' : 'text-nowrap'}`
)
</script>

<style scoped>
.TwcButton {
  touch-action: manipulation;
}
</style>
